import { Checkbox } from 'src/components/ui/checkbox';
import { ComboBox } from 'src/components/credit/ui/comboBox/ComboBox';
import { getStateOptions } from '../../utils';
import { IError } from '../BusinessInfo';
import Input from 'src/components/forms/input';
import { IUser } from 'src/utils/interfaces/user';
import { useCreditForm } from 'src/customHooks/useCreditForm';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import {
    formatPhone,
    formatPostalCode_CA,
    formatPostalCode_US,
} from 'src/utils/formatInputs';
import { NUMBER_FIVE, NUMBER_ZERO } from 'src/utils/constants';
import React, { useState } from 'react';

interface IProps {
    handlerEdit: Function;
    setBusinessModel: Function;
    setBusinessErrorModel: Function;
    object: {
        previous: Array<{ value: string }>;
        bank: string;
        checking: boolean;
        savings: boolean;
        creditLine: boolean;
        branch: string;
        accountNumber: string;
        addressLine1: string;
        addressLine2: string;
        city: string;
        province: string;
        postalCode: string;
        telephone: string;
    };
    errors: {
        previous: Array<IError>;
        bank: IError;
        checking: IError;
        savings: IError;
        creditLine: IError;
        branch: IError;
        accountNumber: IError;
        addressLine1: IError;
        addressLine2: IError;
        city: IError;
        province: IError;
        postalCode: IError;
        telephone: IError;
    };
    disabled: boolean;
}

const ReferencesComponent = ({
    handlerEdit,
    object,
    errors,
    disabled,
    setBusinessModel,
    setBusinessErrorModel,
}: IProps) => {
    const { businessComercial, occupationIndividualInformation } =
        useLocalization();
    const { markCreditFormTouched } = useCreditForm();
    const dealerDataInfo = useSelector((state: IUser) => {
        return state.dealerDataInfo;
    });
    const [oldPhone, setOldPhone] = useState<string>('');
    const propertyName = 'references';
    const isCanada =
        dealerDataInfo?.dealer.country === 'Canada' ||
        dealerDataInfo?.dealer.country === 'CA';
    const stateOptions = getStateOptions(
        isCanada,
        occupationIndividualInformation,
    );
    const postalcodeMaxLen = isCanada ? Number('7') : Number('5');
    const postalcodeVal = !isCanada
        ? object.postalCode.slice(NUMBER_ZERO, NUMBER_FIVE)
        : object.postalCode;

    const handlePostalChange = (e: any) => {
        let value = e.target.value.trim().toUpperCase();
        if (value.length > postalcodeVal.length) {
            if (!isCanada) {
                value = formatPostalCode_US(value);
            } else {
                value = formatPostalCode_CA(value);
            }
        }
        handlerEdit(
            {
                name: 'postalCode',
                value,
            },
            propertyName,
        );
    };
    const validatePhone = (e: any) => {
        let aux: string = e.target.value
            .split('(')
            .join()
            .split(')')
            .join()
            .split('-')
            .join();
        aux = aux.replaceAll(',', '').replaceAll(' ', '');
        if (/^[0-9]*$/.test(aux)) {
            let newValue = '';
            if (e.target.value.length > oldPhone.length) {
                newValue = formatPhone(e.target.value);
            } else {
                newValue = e.target.value;
            }
            handlerEdit(
                {
                    name: e.target.name,
                    value: newValue,
                },
                propertyName,
            );
            setOldPhone(e.target.value);
        }
        markCreditFormTouched();
    };
    function addReference() {
        setBusinessModel((prev: any) => {
            console.log('object', object);
            console.log('Prev Reference', prev);
            const model = {
                ...prev,
            };
            model[propertyName].previous = [...object.previous, { value: '' }];
            return model;
        });
        setBusinessErrorModel((prev: any) => {
            const err = {
                ...prev,
            };
            err[propertyName].previous = [
                ...errors.previous,
                {
                    error: false,
                    msg: '',
                },
            ];
            return err;
        });
    }
    return (
        <div className={'business-references u-mt-large'}>
            <span className='c-form-section__header-content'>
                <span className='c-form-section__title  js-form-section__trigger'>
                    <span
                        className='c-form-section__title-text form-section__title-font'
                        role='heading'
                    >
                        {businessComercial.REFERENCE_TITLE}
                    </span>
                </span>
            </span>
            {object.previous.length
                ? object.previous.map((ele, key) => {
                      return (
                          <div key={key}>
                              <div className='o-fieldset__row' key={key}>
                                  <div className='o-layout'>
                                      <div className='o-layout__item  u-1/2 u-1/1@xs'>
                                          <Input
                                              labelName={
                                                  businessComercial.REFERENCE_PREVIOUSCAR
                                              }
                                              type={'text'}
                                              name={`previous-${key}`}
                                              handlerChange={(e: any) => {
                                                  handlerEdit(
                                                      e.target,
                                                      propertyName,
                                                  );
                                              }}
                                              maxlength={30}
                                              value={object.previous[key].value}
                                              asTouched={
                                                  errors.previous[key].error
                                              }
                                              asErrors={
                                                  errors.previous[key].msg
                                              }
                                          />
                                          {key === Number('0') ? (
                                              <button
                                                  className='c-btn c-btn--secondary'
                                                  type='button'
                                                  onClick={() => {
                                                      addReference();
                                                      markCreditFormTouched();
                                                  }}
                                                  disabled={disabled}
                                              >
                                                  <span className='c-btn__text'>
                                                      {
                                                          businessComercial.REFERENCE_ADDREFERENCE
                                                      }
                                                  </span>
                                              </button>
                                          ) : (
                                              <button
                                                  className='c-btn c-btn--secondary'
                                                  type='button'
                                                  disabled={disabled}
                                                  onClick={() => {
                                                      markCreditFormTouched();
                                                      setBusinessModel(
                                                          (prev: any) => {
                                                              const aux = {
                                                                  ...prev,
                                                              };
                                                              aux[
                                                                  propertyName
                                                              ].previous.splice(
                                                                  key,
                                                                  Number('1'),
                                                              );
                                                              return aux;
                                                          },
                                                      );
                                                      setBusinessErrorModel(
                                                          (prev: any) => {
                                                              const aux = {
                                                                  ...prev,
                                                              };
                                                              aux[
                                                                  propertyName
                                                              ].previous.splice(
                                                                  key,
                                                                  Number('1'),
                                                              );
                                                              return aux;
                                                          },
                                                      );
                                                  }}
                                              >
                                                  <span className='c-btn__text'>
                                                      {
                                                          businessComercial.REFERENCE_REMOVEREFERENCE
                                                      }
                                                  </span>
                                              </button>
                                          )}
                                      </div>
                                  </div>
                              </div>
                              <br />
                              <hr></hr>
                          </div>
                      );
                  })
                : null}
            {isCanada && (
                <>
                    <div className='o-fieldset__row'>
                        <div className='o-layout'>
                            <div className='o-layout__item  u-1/2 u-1/1@xs'>
                                <Input
                                    labelName={
                                        businessComercial.REFERENCE_BANKNAME
                                    }
                                    type={'text'}
                                    name={'bank'}
                                    handlerChange={(e: any) => {
                                        handlerEdit(e.target, propertyName);
                                    }}
                                    maxlength={30}
                                    value={object.bank}
                                    asTouched={errors.bank.error}
                                    asErrors={errors.bank.msg}
                                />
                            </div>
                            <div className='o-layout__item  u-1/2  u-1/1@xs'>
                                <div className='c-form-field'>
                                    <label
                                        htmlFor='m1l7e063'
                                        className='c-form-field__label'
                                    >
                                        {businessComercial.REFERENCE_TYPE}
                                    </label>
                                    <div className='c-form-field__box'>
                                        <div className='c-input column-row u-mt-small'>
                                            <div className='checkbox-box'>
                                                <Checkbox
                                                    name={
                                                        businessComercial.REFERENCE_TYPES_CHECKING
                                                    }
                                                    value={'checking'}
                                                    onCheck={(e: any) => {
                                                        handlerEdit(
                                                            {
                                                                name: 'checking',
                                                                value: e,
                                                            },
                                                            propertyName,
                                                        );
                                                    }}
                                                    checked={object.checking}
                                                    allBlack={true}
                                                />
                                            </div>
                                            <div className='checkbox-box u-ml-small'>
                                                <Checkbox
                                                    name={
                                                        businessComercial.REFERENCE_TYPES_SAVINGS
                                                    }
                                                    value={'savings'}
                                                    onCheck={(e: any) => {
                                                        handlerEdit(
                                                            {
                                                                name: 'savings',
                                                                value: e,
                                                            },
                                                            propertyName,
                                                        );
                                                    }}
                                                    checked={object.savings}
                                                    allBlack={true}
                                                />
                                            </div>
                                            <div className='checkbox-box u-ml-small'>
                                                <Checkbox
                                                    name={
                                                        businessComercial.REFERENCE_TYPES_LINE
                                                    }
                                                    value={'creditLine'}
                                                    onCheck={(e: any) => {
                                                        handlerEdit(
                                                            {
                                                                name: 'creditLine',
                                                                value: e,
                                                            },
                                                            propertyName,
                                                        );
                                                    }}
                                                    checked={object.creditLine}
                                                    allBlack={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='o-fieldset__row'>
                        <div className='o-layout'>
                            {isCanada ? (
                                <div className='o-layout__item  u-1/2 u-1/1@xs'>
                                    <Input
                                        labelName={
                                            businessComercial.REFERENCE_BRANCH
                                        }
                                        type={'text'}
                                        name={'branch'}
                                        handlerChange={(e: any) => {
                                            markCreditFormTouched();
                                            if (/^[0-9]*$/.test(e.target.value))
                                                handlerEdit(
                                                    e.target,
                                                    propertyName,
                                                );
                                        }}
                                        maxlength={5}
                                        value={object.branch}
                                        asTouched={errors.branch.error}
                                        asErrors={errors.branch.msg}
                                    />
                                </div>
                            ) : null}
                            <div className='o-layout__item  u-1/2  u-1/1@xs'>
                                <Input
                                    labelName={
                                        businessComercial.REFERENCE_ACCOUNTNO
                                    }
                                    type={'text'}
                                    name={'accountNumber'}
                                    maxlength={12}
                                    handlerChange={(e: any) => {
                                        markCreditFormTouched();
                                        if (/^[0-9]*$/.test(e.target.value))
                                            handlerEdit(e.target, propertyName);
                                    }}
                                    value={object.accountNumber}
                                    asTouched={errors.accountNumber.error}
                                    asErrors={errors.accountNumber.msg}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='o-fieldset__row'>
                        <div className='o-layout'>
                            <div className='o-layout__item  u-1/2 u-1/1@xs'>
                                <Input
                                    labelName={
                                        businessComercial.REFERENCE_ADDRESS1
                                    }
                                    type={'text'}
                                    name={'addressLine1'}
                                    handlerChange={(e: any) => {
                                        handlerEdit(e.target, propertyName);
                                    }}
                                    maxlength={40}
                                    value={object.addressLine1}
                                    asTouched={errors.addressLine1.error}
                                    asErrors={errors.addressLine1.msg}
                                />
                            </div>
                            <div className='o-layout__item  u-1/2  u-1/1@xs'>
                                <Input
                                    labelName={
                                        businessComercial.REFERENCE_ADDRESS2
                                    }
                                    type={'text'}
                                    name={'addressLine2'}
                                    maxlength={25}
                                    handlerChange={(e: any) => {
                                        handlerEdit(e.target, propertyName);
                                    }}
                                    value={object.addressLine2}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='o-fieldset__row'>
                        <div className='o-layout'>
                            <div className='o-layout__item  u-1/3 u-1/1@xs'>
                                <Input
                                    labelName={businessComercial.REFERENCE_CITY}
                                    type={'text'}
                                    name={'city'}
                                    handlerChange={(e: any) => {
                                        handlerEdit(e.target, propertyName);
                                    }}
                                    maxlength={30}
                                    value={object.city}
                                    asTouched={errors.city.error}
                                    asErrors={errors.city.msg}
                                />
                            </div>
                            <div className='o-layout__item  u-1/3  u-1/1@xs'>
                                <div className='c-form-field'>
                                    <label
                                        htmlFor='m1l7e063'
                                        className='c-form-field__label'
                                    >
                                        {businessComercial.REFERENCE_PROVINCE}
                                    </label>
                                    <div className='c-form-field__box'>
                                        <div className='c-input'>
                                            <ComboBox
                                                name={'optionBusinessProvince'}
                                                options={stateOptions}
                                                defaultValue={object.province}
                                                placeholder={
                                                    businessComercial.APPLICANT_CHOOSEPROVINCE
                                                }
                                                selectedOption={object.province}
                                                onSelect={(value) => {
                                                    handlerEdit(
                                                        {
                                                            name: 'province',
                                                            value,
                                                        },
                                                        propertyName,
                                                    );
                                                }}
                                                disabled={disabled}
                                            />
                                            {errors.province.error &&
                                                errors.province.msg && (
                                                    <span
                                                        className={
                                                            'c-error-message'
                                                        }
                                                    >
                                                        {errors.province.msg}
                                                    </span>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='o-layout__item  u-1/3  u-1/1@xs'>
                                <Input
                                    labelName={
                                        businessComercial.REFERENCE_POSTAL
                                    }
                                    type={'text'}
                                    name={'postalCode'}
                                    handlerChange={handlePostalChange}
                                    maxlength={postalcodeMaxLen}
                                    value={postalcodeVal}
                                    asTouched={errors.postalCode.error}
                                    asErrors={errors.postalCode.msg}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='o-fieldset__row'>
                        <div className='o-layout'>
                            <div className='o-layout__item  u-1/2  u-1/1@xs'>
                                <Input
                                    labelName={
                                        businessComercial.REFERENCE_TELEPHONE
                                    }
                                    type={'text'}
                                    name={'telephone'}
                                    handlerChange={validatePhone}
                                    value={object.telephone}
                                    maxlength={14}
                                    min={0}
                                    asTouched={errors.telephone.error}
                                    asErrors={errors.telephone.msg}
                                />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default ReferencesComponent;
